module.exports = __webpack_public_path__ + "static/media/DetalleCurso1.da29fd5d.svg";